import { useState } from "react";
import { Save } from "lucide-react";
import { toast } from "sonner";
import { qualApi, qualErr, CARD, INPUT, BTN, LABEL } from "./esriQualApi";
import { DateField } from "./DateField";

export function AccountCard({ config, onChange }) {
  const [ref, setRef] = useState(config.account_reference || "");
  const [exp, setExp] = useState(config.token_expires_at ? config.token_expires_at.slice(0, 10) : "");
  const save = async () => {
    try {
      await qualApi.patch({ account_reference: ref, token_expires_at: `${exp}T23:59:00+00:00`, account_status: "ACTIVE", license_validated: true });
      toast.success("Compte et expiration enregistrés (journalisés)"); onChange();
    } catch (e) { toast.error(qualErr(e)); }
  };
  return (
    <section data-testid="esri-account-card" className={CARD}>
      <h2 className="font-chivo text-base md:text-lg font-black uppercase tracking-tight">Compte ArcGIS & expiration (facultatif)</h2>
      <p className="font-mono text-[10px] text-[#525252]">Informatif : une date déclarée dépassée bloque Esri ; une date inconnue génère seulement un avertissement.</p>
      <div className="grid sm:grid-cols-2 gap-3">
        <div>
          <label className={LABEL}>Référence du compte (jamais la clé)</label>
          <input data-testid="esri-account-ref-input" value={ref} onChange={(e) => setRef(e.target.value)} className={INPUT} maxLength={120} placeholder="ex. ArcGIS Location Platform — org SKYCORE" />
        </div>
        <div>
          <label className={LABEL}>Date d'expiration réelle de la clé</label>
          <DateField testid="esri-token-expiry-input" value={exp} onChange={setExp} min={new Date().toISOString().slice(0, 10)} />
        </div>
      </div>
      <div className="flex items-center justify-between gap-2">
        <span data-testid="esri-account-status" className="font-mono text-[10px] text-[#A3A3A3]">STATUT : {config.account_status} · LICENCE : {config.license_validated ? "VALIDÉE" : "NON"} · EXPIRATION : {config.token_expires_at || "inconnue"}</span>
        <button data-testid="esri-account-save-btn" onClick={save} disabled={!ref || !exp} className={BTN}><Save size={12} /> Enregistrer</button>
      </div>
    </section>
  );
}
